export enum RoutePaths {
  BASE = "/",
  DASHBOARD = "/dashboard",
  PROFILE = "/profile",
  SETTINGS = "/settings",
  GROUPS = "/groups",
  NEW_GROUP = "/groups/new",
  GROUP = "/group",
}
